import { Adjust } from '@mui/icons-material';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const customerTransactions = {
    id: 'customerTransactions',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'customerTransactions',
            title: 'Customer Transactions',
            type: 'item',
            url: '/customerTransactions',
            icon: ChangeCircleIcon,
            breadcrumbs: false,
            
        }
    ]
};

export default customerTransactions;
